import Sidebar from "components/navigation-2/sidebar";

export default function LayoutDashboard({ children }) {
    return (
        <div className="page">
            <Sidebar>
                <div className="page-wrapper">
                    {children}
                </div>
            </Sidebar>
        </div>
    );
}
